import PropTypes from 'prop-types';
import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import styles from './PortfolioTour.module.scss';

// Components for steps
const Step1 = ({}) => {
  return (
    <div className={styles.stepContainer}>
      <div>
        Your portfolio is where you showcase your work, skills and experiences.
      </div>
      <br />
      <div>
        The more you add, the more effective it will be at helping you get
        hired.
      </div>
    </div>
  );
};

const Step2 = ({}) => {
  const updatingSkills = require('./assets/updating-skills.gif').default;
  return (
    <div className={styles.stepContainer}>
      <div>
        Your featured roles are the first thing clients see on your portfolio.
        Your skills are the narrow down your expertise.
      </div>
      <br />
      <div>
        Click the pencil icon to edit any section and click "Save" when
        finished.
      </div>
      <br />
      <div>
        <img
          alt="Updating skills on your portfolio"
          src={updatingSkills}
          className={styles.stepImage}
        />
      </div>
    </div>
  );
};

const Step3 = ({}) => {
  const languageComponent = require('./assets/language-component.png').default;
  return (
    <div className={styles.stepContainer}>
      <div>
        There are more sections on your portfolio, such as language skills,
        education, qualifications and industry experience.
      </div>
      <br />
      <div>These help you stand out from other candidates.</div>
      <br />
      <div>
        <img
          alt="Language component"
          src={languageComponent}
          className={styles.stepImage}
        />
      </div>
    </div>
  );
};

const Step4 = ({}) => {
  return (
    <div className={styles.stepContainer}>
      <div>You can upload examples of your work to your portfolio.</div>
      <br />
      <div>
        This is particularly useful for creative roles, or if you want to show
        off a specific project you worked on.
      </div>
      <br />
      <div>Click "New Project" to add a new example.</div>
    </div>
  );
};

// TourSteps component
const stepComponentAnimation = {
  classNames: 'animation-fadein-v1',
  transitionEnter: true,
  // transitionAppear: false,
  transitionExit: false,
  timeout: {
    enter: 500,
  },
};

const TourSteps = ({ currentStep }) => {
  let RenderedStep = null;
  switch (currentStep) {
    case 1:
      RenderedStep = Step1;
      break;
    case 2:
      RenderedStep = Step2;
      break;
    case 3:
      RenderedStep = Step3;
      break;
    case 4:
      RenderedStep = Step4;
      break;
    default:
      RenderedStep = Step1;
      break;
  }

  return (
    <div>
      <TransitionGroup>
        <CSSTransition {...stepComponentAnimation}>
          <div key={currentStep}>
            <RenderedStep />
          </div>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
};

TourSteps.propTypes = {
  currentStep: PropTypes.number.isRequired,
};

TourSteps.defaultProps = {
  currentStep: 1,
};

export default TourSteps;
